import axios from "axios";

// export const BASE_URL =
//   "https://staging-requiresign-test.caprover-testing.mtechub.com/"; // Your API base URL BACKEND

// export const BASE_URL = "http://localhost:3004/"; // Your API base URL BACKEND
import {
  getActiveRegion,
  getApiBaseUrl,
  getLinkBaseUrl,
} from "../configs/regionConfig";

export const bulkLinkTermsAndConditionLink = "/terms-and-conditions"; // Bulk link response pAGE TERMS AND CONDITION
export let BASE_URL = getApiBaseUrl();
export let link_base_url = getLinkBaseUrl();
export let FrontendBaseUrl = getActiveRegion().portal;

export function refreshRegionExports() {
  BASE_URL = getApiBaseUrl();
  link_base_url = getLinkBaseUrl();
  FrontendBaseUrl = getActiveRegion().portal;
}
refreshRegionExports();

/**
 * Utility function to detect if current URL has a subdomain
 * and return appropriate front-end URL format
 * @returns {string} The base URL with or without subdomain
 */
export const getBaseUrlWithSubdomain = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // Frontend port (hardcoded for clarity, but can be made dynamic)
  const frontendPort = "3000";

  // Check if hostname contains a subdomain
  const parts = hostname.split(".");
  const hasSubdomain =
    parts.length > 2 ||
    (parts.length === 2 && parts[0] !== "www" && parts[1] !== "com");

  if (hasSubdomain) {
    // Extract subdomain part
    const subdomain = parts[0];

    // For localhost development, use subdomain.localhost:3000 format
    if (hostname.includes("localhost")) {
      return `${protocol}//${subdomain}.localhost:${frontendPort}/`;
    }

    // For production domains, preserve the subdomain structure
    // Assuming the main domain is the last two parts (e.g., example.com)
    const mainDomain = parts.slice(-2).join(".");
    return `${protocol}//${subdomain}.${mainDomain}/`;
  } else {
    // No subdomain - use standard frontend URL
    return FrontendBaseUrl;
  }
};

// Helper function to generate URLs for specific pages with subdomain support
export const getUrlWithSubdomain = (path) => {
  const baseUrl = getBaseUrlWithSubdomain();
  // Ensure we don't have double slashes between base URL and path
  const baseWithoutTrailingSlash = baseUrl.endsWith("/")
    ? baseUrl.slice(0, -1)
    : baseUrl;
  const pathWithoutLeadingSlash = path.startsWith("/") ? path.slice(1) : path;

  return `${baseWithoutTrailingSlash}/${pathWithoutLeadingSlash}`;
};

/**
 * Generate a URL for the esign-setup page that preserves subdomain if present
 * @param {string} pathParams - Optional path parameters to append
 * @returns {string} The complete URL to the esign-setup page
 */
export const getEsignSetupUrl = (pathParams = "") => {
  const baseUrl = getBaseUrlWithSubdomain();
  return `${baseUrl}esign-setup${pathParams}`;
};

// Example usage for redirection:
export const redirectToEsignSetup = (documentId) => {
  const url = getEsignSetupUrl(`?documentId=${documentId}`);
  window.location.href = url;
};

export const websiteBaseUrl = "https://requiresign.com/"; // Your API base URL FRONTEND+
export const termsConditions = `${websiteBaseUrl}terms-conditions`;
// export const FrontendBaseUrl = "http://localhost:3000/"; // Your API base URL FRONTEND+
// export const FrontendBaseUrl = "https://req-sign-portal.netlify.app/"; // Your API base URL FRONTEND+
// https://boisterous-praline-59adf0.netlify.app/login

export const IPGetUrl2 = "https://worldtimeapi.org/api/ip/"; // GET TIME ZONE

export const IPGetUrl = "https://worldtimeapi.org/api/ip/"; // GET TIME ZONE
export const bulkLiverifyEmailnkTermsAndConditionLink = "/terms-and-conditions"; // Bulk link response pAGE TERMS AND CONDITION

// using it
export const GetCurrentIPCountry =
  "https://api.ipgeolocation.io/ipgeo?apiKey=a8cc5ab42a5045278fbe3833f4f6f1b1"; //paid

export const jpg_image1 =
  "https://res.cloudinary.com/dlm56y4v4/image/upload/v1714458748/logoRemoveBg_i9gwty.png";
// Handle connection errors globally
const handleRequestError = (error) => {
  if (error.message.includes("ERR_CONNECTION_REFUSED")) {
    return {
      error: true,
      message: "Backend server is down. Please try again later.",
    };
  } else if (error.message.includes("Network Error")) {
    return {
      error: true,
      message: "You are offline. Please check your internet connection.",
    };
  } else {
    return { error: true, message: `An error occurred: ${error.message}` };
  }
};
export const get = async (url) => {
  try {
    const response = await fetch(`${getApiBaseUrl()}${url}`);
    if (!response.ok) {
      throw new Error(`Error fetching data: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    return handleRequestError(error);
  }
};

export const universalLinkPost = async (url, data) => {
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const post = async (url, data) => {
  try {
    const response = await axios.post(`${getApiBaseUrl()}${url}`, data);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const postHeaders = async (url, data, headers) => {
  try {
    const response = await axios.post(`${getApiBaseUrl()}${url}`, data, { headers });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const put = async (url, data) => {
  try {
    const response = await axios.put(`${getApiBaseUrl()}${url}`, data);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const deleteReq = async (url) => {
  try {
    const response = await axios.delete(`${getApiBaseUrl()}${url}`);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};
export const postFormData = async (data) => {
  const formData = new FormData();
  formData.append("file", data.image);
  formData.append("user_id", data.user_id);

  try {
    const response = await axios.post(`${getApiBaseUrl()}uploadidrive`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const postFormDataPdfDb = async (data, progressCallback) => {
  const formData = new FormData();
  formData.append("file", data.image);

  try {
    const response = await axios.post(`${getApiBaseUrl()}upload-pdf`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        progressCallback(progress);
      },
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const postFormDataPdf = async (data, progressCallback) => {
  const formData = new FormData();
  formData.append("file", data.image);
  formData.append("user_id", data.user_id);

  try {
    const response = await axios.post(`${getApiBaseUrl()}uploadidrive`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        progressCallback(progress);
      },
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

export const postFormDataPdfReplace = async (data, progressCallback) => {
  const formData = new FormData();
  formData.append("file", data.image);
  formData.append("user_id", data.user_id);
  formData.append("file_id", data.file_id);
  formData.append("noDec", data.noDec);

  try {
    const response = await axios.post(`${getApiBaseUrl()}replace`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        progressCallback(progress);
      },
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};
// import { GetCurrentIPCountry } from "../../apis/api";

export const getUserLocation = async () => {
  try {
    const response = await fetch(`${GetCurrentIPCountry}`);

    if (!response.ok) {
      throw new Error(`Error retrieving user location: ${response.statusText}`);
    }

    const responseData = await response.json();

    console.log("ip data");
    console.log(responseData);
    // Calculate based on UTC as standard time
    let region = "";
    // Extract time zone information
    const timezoneName = responseData?.time_zone?.name || "Unknown";
    const isDST = responseData?.time_zone?.is_dst;
    const offset = responseData?.time_zone?.offset;
    console.log("asdhjgahdahjdgsjfh ", timezoneName);
    console.log("8932832487234 ", responseData?.time_zone);

    console.log("asdhjgahdahjdgsjfh ", isDST);
    console.log("asdhjgahdahjdgsjfh ", offset);

    switch (offset) {
      case -8: // Pacific Time
        region = isDST ? "PDT" : "PST";
        break;
      case -7: // Mountain Time
        region = isDST ? "MDT" : "MST";
        break;
      case -6: // Central Time
        region = isDST ? "CDT" : "CST";
        break;
      case -5: // Eastern Time
        region = isDST ? "EDT" : "EST";
        break;
      case 0: // UTC
        region = "UTC";
        break;
      default:
        region = `UTC${offset > 0 ? `+${offset}` : offset}`;
        break;
    }

    console.log("Region based on time zone:", region);
    console.log("Region based on Standard Time (UTC as baseline):", region);

    let data = {
      ip: responseData?.ip || "N/A", // Handle both IPv4 and IPv6
      country: responseData?.country_code2 || "N/A",
      date: responseData?.time_zone?.current_time || "N/A",
      timezone: responseData?.time_zone?.name || "N/A",
      region: region || "N/A",
    };

    return data;
  } catch (error) {
    console.error("Error retrieving user location:", error);
    let data1 = {
      ip: "-",
      country: "-",
      date: "-",
      timezone: "-",
    };
    return data1;
  }
  // usage
};
